import type { ConfigValue } from '../base';

export const AppInstallationStatus = {
  COMPLETED: 'COMPLETED',
  DISABLED: 'DISABLED',
  PENDING: 'PENDING',
} as const;

export type AppInstallation = {
  id: string;
  config: ConfigValue;
  status: keyof typeof AppInstallationStatus;
};
